import { Component, forwardRef, OnInit } from '@angular/core';
import { EContentLocation } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { WidgetBaseComponent } from '../../widget-base/widget-base.component';

import { FormsModule } from '@angular/forms';
import { ContentBaseComponent } from '../../content/content-base.component';

@Component({
    selector: 'app-widget-content-card',
    imports: [
    FormsModule,
    forwardRef(() => ContentBaseComponent)
],
    templateUrl: './widget-content-card.component.html',
    styleUrls: ['./widget-content-card-base.component.scss']
})
export class WidgetContentCardBaseComponent extends WidgetBaseComponent implements OnInit {
  public contentParent: string | undefined;
  public contentLocation: EContentLocation | undefined;

  public ngOnInit(): void {
    this.contentParent = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("PageName") == 0)?.value;
    let contentLocationString = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("ContentLocation") == 0)?.value;
    if (contentLocationString != undefined) {
      this.contentLocation = (<any>EContentLocation)[contentLocationString];
    }
  }

}
